import { render, staticRenderFns } from "./WorkshopsCycle3.vue?vue&type=template&id=66fa1ce9&scoped=true&"
import script from "./WorkshopsCycle3.vue?vue&type=script&lang=js&"
export * from "./WorkshopsCycle3.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopsCycle3.vue?vue&type=style&index=0&id=66fa1ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa1ce9",
  null
  
)

export default component.exports